import React, { useState } from "react";
import ReactModal from "react-modal";
import caret_down from "../../../Assets/caret-down.png";
import close from "../../../Assets/closeIcon.svg";
import caret_up from "../../../Assets/caret_up.png";
import calendarIcon from "../../../Assets/calendarIcon.svg";
const FormStatusModal = ({ isOpen, onClose, settings, setSettings, save }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      borderRadius: "15px",
      transform: "translate(-50%, -50%)",
      width: "35%",
      height: "80%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "Space-between",
      gap: "2rem",
      padding: "px !important",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };
  const [showDropDown, setShowDrop] = useState(false);

  // selected status for form
  const handelSelectedValue = (value) => {
    setShowDrop(false);
    setSettings({ ...settings, formStatus: value });
  };
  //Get Form Status
  const getFormStatus = (value) => {
    if (value === "enabled" || value === "Enabled") {
      return "Enabled";
    } else if (value === "disabled") {
      return "Disabled";
    } else if (value === "disableOnDate") {
      return "Disable on specific date";
    } else if (value === "disableOnLimit") {
      return "Disable on response limit";
    } else if (value === "disableOnDateAndLimit") {
      return "Disable on specific date and response limit";
    }
  };

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showYearPicker, setYearPicker] = useState(false);
  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };
  const [inputValue, setInputValue] = useState(
    selectedDate.toISOString().substr(0, 10)
  );

  const handleDateClick = (day) => {
    const newDate = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      day,
      0,
      0
    );
    setSelectedDate(newDate);
    const offset = newDate.getTimezoneOffset() * 60000; // Get timezone offset in milliseconds
    const localISOTime = new Date(newDate.getTime() - offset)
      .toISOString()
      .substring(0, 10); // Adjust date and get ISO string
    setInputValue(localISOTime);
    setSettings({ ...settings, disableOnDate: localISOTime });
    setShowCalendar(false);
  };

  const handleMonthClick = (month) => {
    const newDate = new Date(selectedDate.getFullYear(), month, 1);
    setSelectedDate(newDate);
    const offset = newDate.getTimezoneOffset() * 60000; // Get timezone offset in milliseconds
    const localISOTime = new Date(newDate.getTime() - offset)
      .toISOString()
      .substring(0, 10); // Adjust date and get ISO string
    setInputValue(localISOTime);
    setYearPicker(false);
  };
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);

    const [year, month, day] = newValue.split("-");
    const newDate = new Date(year, month - 1, day);
    console.log(newDate, "date");
    newDate.setHours(0, 0, 0, 0);
    if (!isNaN(newDate)) {
      setSelectedDate(newDate);
      setSettings({ ...settings, disableOnDate: newDate });
    }
  };
  const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const renderCalendar = () => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = new Date(year, month, 1).getDay();

    const days = [];
    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<div key={`empty-${i}`} className="day empty"></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const isSelected = day === selectedDate.getDate();
      days.push(
        <div
          key={day}
          className={`day ${isSelected ? "selected" : ""}`}
          onClick={() => handleDateClick(day)}
        >
          {day}
        </div>
      );
    }
    const currentYear = selectedDate.getFullYear();
    const yearRange = [];
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      yearRange.push(i);
    }

    const truncateText = (text, maxLength) => {
      if (text?.length <= maxLength) {
        return text;
      }
      return text?.slice(0, maxLength);
    };
    return (
      <>
        {showYearPicker ? (
          <div
            className="month_option"
            style={{
              position: "absolute",
              top: "2.4rem",
              width: "100%",
              backgroundColor: "#fff",
              padding: "1rem",
            }}
          >
            <div className="header" style={{ width: "100%" }}>
              <button
                onClick={() => setSelectedDate(new Date(year - 1, month, 1))}
              >
                &lt;
              </button>
              <div onClick={() => setYearPicker(true)}>{year}</div>
              <button
                onClick={() => setSelectedDate(new Date(year + 1, month, 1))}
              >
                &gt;
              </button>
            </div>
            <div
              style={{ width: "100%" }}
              className="datePicker-in-generalSetting"
            >
              {months.map((monthName, index) => (
                <div
                  key={index}
                  className="month-option"
                  onClick={() => handleMonthClick(index)}
                >
                  {/* {monthName} */}
                  {truncateText(monthName, 3)}
                </div>
              ))}{" "}
            </div>
          </div>
        ) : (
          <div
            className="calendar"
            style={{
              position: "absolute",
              top: "2.4rem",
              width: "100%",
              backgroundColor: "#fff",
            }}
          >
            <div className="header">
              <button
                onClick={() => setSelectedDate(new Date(year, month - 1, 1))}
              >
                &lt;
              </button>
              <div onClick={() => setYearPicker(true)}>
                {months[month]} {year}
              </div>
              <button
                onClick={() => setSelectedDate(new Date(year, month + 1, 1))}
              >
                &gt;
              </button>
            </div>
            <div className="days-of-week">
              {daysOfWeek.map((day, index) => (
                <div key={index} className="day-of-week">
                  {day}
                </div>
              ))}
            </div>
            <div className="days">{days}</div>
          </div>
        )}
      </>
    );
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
    >
      <div className="modal-conrainer-status">
        <div className="top-bar-status">
          <div className="title-modal">FORM STATUS</div>
          <img src={close} alt="" onClick={onClose} />
        </div>
        <hr />
        <div className="deletion-period-container">
          <div className="deletion-period-text">Deletion Period</div>
          <div className="deletion-period-des">
            Enable, disable, or conditionally enable your form
          </div>
        </div>
        <div className="deletion-type">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
            onClick={() => setShowDrop(!showDropDown)}
          >
            <div>{getFormStatus(settings.formStatus)}</div>
            {showDropDown ? (
              <img src={caret_up} alt="caret_up" />
            ) : (
              <img src={caret_down} alt="caret-down" />
            )}
          </div>
          {showDropDown && (
            <div className="dropdown-menu-deletion" style={{ zIndex: 10 }}>
              <div
                className="list-item-dropdown"
                onClick={() => handelSelectedValue("enabled")}
              >
                Enable
              </div>
              <div
                className="list-item-dropdown"
                onClick={() => handelSelectedValue("disabled")}
              >
                Disable{" "}
              </div>
              <div
                className="list-item-dropdown"
                onClick={() => handelSelectedValue("disableOnDate")}
              >
                Disable on specific date
              </div>
              <div
                className="list-item-dropdown"
                onClick={() => handelSelectedValue("disableOnLimit")}
              >
                Disable on response limit
              </div>
              <div
                className="list-item-dropdown"
                onClick={() => handelSelectedValue("disableOnDateAndLimit")}
              >
                Disable on specific date and response limit
              </div>
            </div>
          )}
        </div>
        {settings.formStatus === "disableOnDate" && (
          <div className="ExprirationDate-container">
            <div className="expriration-date-time-input">
              <div className="text-head">Expiration Date</div>
              <div className="text-des">Disable form on a date</div>
              <div className="date-time-container-status">
                <div
                  className="calander"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    position: "relative",
                    border: "1px solid #D3DCE5",
                    borderRadius: "6px",
                    paddingRight: "4px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      position: "relative",
                    }}
                  >
                    <input
                      type="date"
                      id="customDate"
                      name="customDate"
                      style={{ outline: "none", fontSize: "1.25rem" }}
                      value={inputValue}
                      onChange={handleInputChange}
                    />
                  </div>
                  <img
                    src={calendarIcon}
                    alt="calendarIcon"
                    className="calanderIcon"
                    onClick={() => setShowCalendar(!showCalendar)}
                  />

                  {showCalendar && renderCalendar()}
                </div>

                <div className="date-time-input-contaienr">
                  <input
                    type="time"
                    style={{ width: "100%" }}
                    value={settings.disableOnTime}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        disableOnTime: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="Warning-message-container">
              <div className="text-head">Warning Message</div>
              <div className="text-des">Set a message for disabled forms</div>
              <input
                className="warning-message-input"
                type="text"
                name="warning-messageF"
                value={settings.ErrorMessage}
                onChange={(e) =>
                  setSettings({ ...settings, ErrorMessage: e.target.value })
                }
              />
            </div>
          </div>
        )}
        {settings.formStatus === "disableOnLimit" && (
          <div className="ExprirationDate-container">
            <div className="Warning-message-container">
              <div className="text-head">Submission Limit</div>
              <div className="text-des">
                Limit the total number of submissions (e.g., 1,000)
              </div>
              <input
                className="warning-message-input"
                type="number"
                name="list-submittion"
                value={settings.responseLimit}
                onChange={(e) =>
                  setSettings({ ...settings, responseLimit: e.target.value })
                }
              />
            </div>
            <div className="Warning-message-container">
              <div className="text-head">Warning Message</div>
              <div className="text-des">Set a message for disabled forms</div>
              <input
                className="warning-message-input"
                value={settings.ErrorMessage}
                type="text"
                name="warning-messageF"
                onChange={(e) =>
                  setSettings({ ...settings, ErrorMessage: e.target.value })
                }
              />
            </div>
          </div>
        )}
        {settings.formStatus === "disableOnDateAndLimit" && (
          <div className="ExprirationDate-container">
            <div className="Warning-message-container">
              <div className="text-head">Submission Limit</div>
              <div className="text-des">
                Limit the total number of submissions (e.g., 1,000)
              </div>
              <input
                className="warning-message-input"
                type="number"
                name="list-submittions"
                value={settings.responseLimit || ""}
                onChange={(e) =>
                  setSettings({ ...settings, responseLimit: e.target.value })
                }
              />
            </div>
            <div className="expriration-date-time-input">
              <div className="text-head">Expiration Date</div>
              <div className="text-des">Disable form on a date</div>
              <div className="date-time-container-status">
                <div
                  className="calander"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    position: "relative",
                    border: "1px solid #D3DCE5",
                    borderRadius: "6px",
                    paddingRight: "4px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      position: "relative",
                    }}
                  >
                    <input
                      type="date"
                      id="customDate"
                      name="customDate"
                      style={{ outline: "none", fontSize: "1.25rem" }}
                      value={inputValue}
                      onChange={handleInputChange}
                    />
                  </div>
                  <img
                    src={calendarIcon}
                    alt="calendarIcon"
                    className="calanderIcon"
                    onClick={() => setShowCalendar(!showCalendar)}
                  />

                  {showCalendar && renderCalendar()}
                </div>

                <div className="date-time-input-contaienr">
                  <input
                    type="time"
                    style={{ width: "100%" }}
                    value={settings.disableOnTime}
                    onChange={(e) =>
                      setSettings({
                        ...settings,
                        disableOnTime: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="Warning-message-container">
              <div className="text-head">Warning Message</div>
              <div className="text-des">Set a message for disabled forms</div>
              <input
                className="warning-message-input"
                type="text"
                name="warning-messageF"
                value={settings.ErrorMessage}
                onChange={(e) =>
                  setSettings({ ...settings, ErrorMessage: e.target.value })
                }
              />
            </div>
          </div>
        )}
      </div>
      <div className="bottom-bar-status">
        <button onClick={onClose} className="buttons cbtn">
          Cancel
        </button>
        <button onClick={save} className="buttons sbtn">
          Save
        </button>
      </div>
    </ReactModal>
  );
};

export default FormStatusModal;
